import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import Select from "react-select";

const AddVarientNew = ({ modalData, setModalData, onSubmit }) => {
  const barcodesymbol = [
    { value: "choose", label: "Choose" },
    { value: "code34", label: "Code34" },
    { value: "code35", label: "Code35" },
    { value: "code36", label: "Code36" },
  ];
  const taxtype = [
    { value: "exclusive", label: "Exclusive" },
    { value: "salesTax", label: "Sales Tax" },
  ];
  const tax = [
    { value: "exclusive", label: "Direct" },
    { value: "salesTax", label: "InDirect" },
  ];
  const discounttype = [
    { value: "choose", label: "Choose" },
    { value: "percentage", label: "Percentage" },
    { value: "cash", label: "Cash" },
  ];

  const handleChange = (field, value) => {
    setModalData((prev) => ({ ...prev, [field]: value }));
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    const base64 = await toBase64(file);
    setModalData((prev) => ({ ...prev, image: base64 }));
  };

  return (
    <div className="modal fade" id="add-variation">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <div className="page-title">
              <h4>{window.translate("addVariant")}</h4>
            </div>
            <button
              type="button"
              className="close bg-danger text-white fs-16"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="modal-title-head people-cust-avatar">
              <h6>{window.translate("variantThumbnail")}</h6>
            </div>
            <div className="new-employee-field">
              <div className="profile-pic-upload">
                <div className="profile-pic">
                  <span>
                    <i data-feather="plus-circle" className="plus-down-add" />{" "}
                    {window.translate("addImage")}
                  </span>
                </div>
                <div className="mb-3">
                  <div className="image-upload mb-0">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                    />

                    <div className="image-uploads">
                      <h4>{window.translate("uploadImage")}</h4>
                    </div>

                    {modalData?.image && (
                      <div
                        className="preview-wrapper position-relative mt-2"
                        style={{
                          width: "120px",
                          height: "120px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src={modalData.image}
                          alt="Variant Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger position-absolute"
                          style={{
                            top: "5px",
                            right: "5px",
                            borderRadius: "50%",
                            padding: "0 6px",
                          }}
                          onClick={() =>
                            setModalData((prev) => ({ ...prev, image: null }))
                          }
                          title="Remove image"
                        >
                          ×
                        </button>
                      </div>
                    )}
                  </div>

                  <p className="mt-2">{window.translate("imageNote")}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 pe-0">
                <div className="mb-3">
                  <label className="form-label">
                    {window.translate("barcodeSymbology")}
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    options={barcodesymbol}
                    value={barcodesymbol.find(
                      (opt) => opt.value === modalData.barcodeSymbology
                    )}
                    onChange={(selected) =>
                      handleChange("barcodeSymbology", selected.value)
                    }
                    placeholder="Choose"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <div className="mb-3 add-product list position-relative">
                    <label className="form-label">
                      {window.translate("itemCode")}
                      <span className="text-danger ms-1">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control list"
                      style={{ paddingRight: "50px" }}
                      value={modalData.itemCode || ""}
                      onChange={(e) => handleChange("itemCode", e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-primaryadd"
                      onClick={() =>
                        handleChange(
                          "itemCode",
                          "ITEM-" + Math.floor(Math.random() * 1000000)
                        )
                      }
                    >
                      {window.translate("generate")}
                    </button>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-12">
                <div className="mb-3 image-upload-down">
                  <div className="image-upload download">
                    <input type="file" />
                    <div className="image-uploads">
                      <ImageWithBasePath
                        src="assets/img/download-img.png"
                        alt="img"
                      />
                      <h4>
                        {window.translate("dragDrop")}{" "}
                        <span>{window.translate("fileToUpload")}</span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="accordion-body">
                  <div className="text-editor add-list add">
                    <div className="col-lg-12">
                      <div className="add-choosen mb-3">
                        <div className="phone-img ms-0">
                          <ImageWithBasePath
                            src="assets/img/products/laptop.png"
                            alt="image"
                          />
                          <Link to="#">
                            <X
                              data-feather="x"
                              className="x-square-add remove-product"
                            />
                          </Link>
                        </div>
                        <div className="phone-img">
                          <ImageWithBasePath
                            src="assets/img/products/laptop-2.png"
                            alt="image"
                          />
                          <Link to="#">
                            <X
                              data-feather="x"
                              className="x-square-add remove-product"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    {window.translate("quantity")}
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={modalData.quantity || ""}
                    onChange={(e) => handleChange("quantity", e.target.value)}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    {window.translate("quantityAlert")}
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={modalData.quantityAlert || ""}
                    onChange={(e) =>
                      handleChange("quantityAlert", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    {window.translate("taxType")}
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    options={tax}
                    value={tax.find((opt) => opt.value === modalData.tax)}
                    onChange={(selected) => handleChange("tax", selected.value)}
                    placeholder="Choose"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    {window.translate("tax")}
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    options={taxtype}
                    value={taxtype.find(
                      (opt) => opt.value === modalData.taxType
                    )}
                    onChange={(selected) =>
                      handleChange("taxType", selected.value)
                    }
                    placeholder="Choose"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">
                    {window.translate("discountType")}
                    <span className="text-danger ms-1">*</span>{" "}
                  </label>
                  <Select
                    classNamePrefix="react-select"
                    options={discounttype}
                    value={discounttype.find(
                      (opt) => opt.value === modalData.discountType
                    )}
                    onChange={(selected) =>
                      handleChange("discountType", selected.value)
                    }
                    placeholder="Choose"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div>
                  <label className="form-label">
                    {window.translate("discountValue")}
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={modalData.discountValue || ""}
                    onChange={(e) =>
                      handleChange("discountValue", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <Link
              to="#"
              className="btn me-1 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
              data-bs-dismiss="modal"
            >
              {window.translate("cancel")}
            </Link>
            <button
              type="button"
              className="btn btn-primary fs-13 fw-medium p-2 px-3"
              onClick={() => onSubmit(modalData)}
            >
              {window.translate("submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AddVarientNew.propTypes = {
  modalData: PropTypes.object.isRequired,
  setModalData: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddVarientNew;
